
export const cleanValue = function(type, value) {
    switch(type) {
        case 0: case 1: case 2: case 3: case 4:
            return (numberWithCommas(value).toString().replace(/[^\d.-]/g, '') * 1) || 0;
        default: return value;
    }
}

export const replaceUnderScore = function(value){
    return value.replace(/_/g, " ");
}

function numberWithCommas(value, type) {
    value = parseFloat(value.toString().replace(/,/g,""));
    if(type && type == 1){
        //Currency format doesn't use decimals
        value = value.toFixed();
    }else{
        value = value.toFixed(1);
    }
    let parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

function toCurrency(value) {
    return (value < 0? '- $': '$') + numberWithCommas(value.toString().replace(/-/g,""), 1);
}

function toPhoneNumber(value) {
    var cleaned = ('' + value).replace(/\D/g, '') || '';
    let newValue = '';

    for (let charIndex = 0; charIndex < cleaned.length; charIndex++) {
        const char = value[charIndex];
        switch(charIndex) {
            case 0: 
                newValue += '(' + char;
                break;
            case 3: 
                newValue += ') ' + char;
                break;
            case 6: 
                newValue += '-' + char;
                break;
            default: 
                newValue += char;
                break;
        }
    }
    return newValue;
  }

export const formatValue = function(type, value) {
    if (isNaN(value * 1)) return value;

    switch(type) {
        case 0: return numberWithCommas(value * 1);
        case 1: return toCurrency(value * 1);
        case 2: return (value * 1).toFixed(1) + '%';
        case 3: return (value * 1).toFixed(1);
        case 4: return (value * 1).toFixed(1) + 'x';
        case 5: return (value * 1).toFixed(1) + ' bps';
        case 7: return (value)? value : '';
        case 8: return value ? value.padStart(6,'0') : '000000';
        case 9: return toPhoneNumber(value);
        default: return value;
    }
}

export const getFormat = function(type) {
    switch(type) {
        case 0: return 'numeric';
        case 1: return 'currency';
        case 2: return 'percentage';
        case 3: return 'days';
        case 4: return 'multiplier';
        case 5: return 'b.p.s';
        default: return 'text';
    }
}
